import { web } from "../middleware";

export const JournalApi = {
  getJournalDetail: (journalId) =>
    web({
      url: `/user-journals/${journalId}/details`,
      method: "GET",
    }),
  getCustomJournalDetail: (payload) =>
    web(
      {
        url: "/user-journals/get-custom-detail",
        method: "POST",
      },
      payload,
    ),
  generateSharePdfUrl: (payload) =>
    web({ url: "/user-journals/generate-share-url", method: "POST" }, payload),
};
